document.addEventListener("alpine:init", () => {
  const HEADERS = {
    Accept: "*/*",
    "Content-Type": "application/json;",
    "X-Requested-With": "XMLHttpRequest",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  };
  async function addItems(items = []) {
    const body = JSON.stringify({
      items: items.map((i) => ({
        ...i,
        properties: { ...i.properties, _p: "default empty property" },
      })),
      sections: "cart-items,cart-footer,cart-item-count",
      sections_url: window.location.pathname,
    });

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: HEADERS,
      body: body,
    });

    return await res.json();
  }

  Alpine.data("pdpPrescriptionHero", ({ sectionId }) => ({
    URI: window.RX_PROXY_CONFIG?.BASE_URL || "/apps/proxy",
    sectionId,
    shopProducts: {},
    mobileSlider: null,
    allProductsByCategory: [],
    allProductsByCategoryFrameEyewear: [],
    framesByGroup: [],
    rxLensProducts: window.RxLensProducts,
    rxLensProduct: window.RxLensProducts[0].product,
    rxLensSelectedVariant: window.RxLensProducts[0].product.selectedVariant,
    rxLensProductOptions: window.RxLensProducts[0].product.productOptions,
    product: null, //means frame product
    selectedVariant: null, //means frame product
    productOptions: null, //means frame product
    qty: 1,
    loading: false,
    isOpenPrescriptionPopup: false,
    isProductInfoOpen: false,
    isOpenFramePopup: false,
    isOpenSizeGuidePopup: false,
    images: [],
    prescriptionItems: [],
    searchParams: new URLSearchParams(window.location.search),
    activeColorGroup: "",
    activeMaterialGroup: "",
    activePDOption: "SINGLE", //SINGLE, DUO
    SPH: {
      R: "Choose",
      L: "Choose",
    },
    PUPIL_RL: {
      RL: "Choose",
    },
    PUPIL: {
      R: "Choose",
      L: "Choose",
    },
    activeTags: {
      frame: null,
      eyewear: null,
    },
    async init() {
      let { product, productOptions, selectedVariant } = JSON.parse(
        this.$el.querySelector("#ev-product-json").textContent
      );

      if (!selectedVariant) {
        selectedVariant = product.variants[0];
      }

      console.log({ product, productOptions, selectedVariant });
      //Set default STATE
      this.setDefaultActiveTags(product.tags);
      this.setDefaultActiveTags(this.rxLensProduct.tags);
      this.setInstance({ product, productOptions, selectedVariant });

      //ASYNC LOGIC
      const shopProducts = await this.getDataFromPage(
        "/pages/shipping?view=prescription-products-json"
      );

      this.shopProducts = shopProducts;

      const framesByGroupMap = new Map();
      Object.values(shopProducts).forEach((product) => {
        const frameTag = product.tags.find((tag) => tag.includes("frame_"));
        if (frameTag) {
          const frameGroup = frameTag.split("~")[0].split("_")[1];
          !framesByGroupMap.has(frameGroup) &&
            framesByGroupMap.set(frameGroup, product);
        }
      });

      this.framesByGroup = Array.from(framesByGroupMap).map(([key, value]) => ({
        frameGroup: key,
        defaultFrameGroupProduct: value,
        image: value.media ? value.media[0]?.src : null,
        allFrames: Object.values(shopProducts).filter((product) => {
          const frameTag = product.tags.find((tag) => tag.includes("frame_"));
          if (frameTag) {
            const frameGroup = frameTag.split("~")[0].split("_")[1];
            return key === frameGroup;
          }
        }),
      }));

      window.addEventListener(
        "message",
        (event) => {
          if (!event?.data?.pd) return;
          this.PUPIL_RL.RL = `${event?.data?.pd}`;
          if (this.activePDOption === "DUO") {
            this.togglePDOption();
          }
          this.closeIframePD();
        },
        false
      );
      

      console.log('rxLensProduct', this.rxLensProduct);
      console.log('rxLensSelectedVariant', this.rxLensSelectedVariant);
      console.log('rxLensProductOptions', this.rxLensProductOptions);
    },
    openIframePD() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$store.stopScroll.enable();

      const $documentEl = document.documentElement;

      $documentEl.insertAdjacentHTML(
        "beforeend",
        `<div
          id="pd-iframe"
          class="fixed z-full inset-0 w-full h-full flex items-center justify-center backdrop-blur-6px bg-white/90"
          @click.self="document.querySelector('#pd-iframe').remove();"
        >
          <div class="relative w-[75vw] h-[75vh] flex overflow-hidden rounded-[32px]">
            <iframe
            class="!w-full !h-full"
              src="https://pd.eazyvisi.com/?primaryColor=FFF&textColor=000&lineColor=FFF&borderRadius=3px"
              width="100%"
              height="100%"
              allow="camera"
            ></iframe>
          </div>
        </div>`
      );
    },
    closeIframePD() {
      this.$store.stopScroll.disable();
      document.querySelector("#pd-iframe") &&
        document.querySelector("#pd-iframe").remove();
    },
    togglePDOption() {
      this.activePDOption = "SINGLE";
      this.PUPIL.L = "Choose";
      this.PUPIL.R = "Choose";
    },
    selectOption({ name }, optionValue) {
      const selectedValue = optionValue;
      const selectedOption = this.rxLensProductOptions.find(
        (option) => option.name === name
      );
      const allOptionValuesWithoutSelected = selectedOption.values.filter(
        (value) => value !== selectedValue
      );
      const targetOptions = [
        selectedValue,
        ...this.rxLensSelectedVariant.options.filter(
          (value) => !allOptionValuesWithoutSelected.includes(value)
        ),
      ];

      this.rxLensProduct.variants.some((variant) => {
        if (variant.options.every((option) => targetOptions.includes(option))) {
          this.rxLensSelectedVariant = variant;
          return true;
        }
      });
    },
    changeProductByProductType({ productType, product }) {
      switch (productType) {
        case "frame_product":
          this.product = product;
          this.selectedVariant = product.variants[0];
          this.productOptions = product.productOptions;
          this.changeUrl({
            product: this.product,
            selectedVariant: this.selectedVariant,
          });

          const rxLensProductsByEyewear = window.RxLensProducts.find(
            (group) => group.tag === this.activeTags.eyewear
          );

          this.rxLensProduct = rxLensProductsByEyewear.product;

          this.rxLensSelectedVariant = this.findVariantByOptions({
            product: rxLensProductsByEyewear.product,
            options: this.rxLensSelectedVariant.options,
          });

          this.rxLensProductOptions =
            rxLensProductsByEyewear.product.productOptions;

          this.getProductMediaAjax(
            `/products/${product.handle}?view=ev-prescription`
          );
          return;
        case "rx_lens_product":
          const eyewear = product.tags.find((tag) => tag.includes("eyewear_"));
          this.activeTags.eyewear = eyewear;
          this.rxLensProduct = product;
          this.rxLensSelectedVariant = product.variants[0];
          this.rxLensProductOptions = product.productOptions;

          return;
      }
    },
    changeVariant({ name }, optionValue) {
      this.selectOption({ name }, optionValue);

      this.setProductImagesByAlt();
      this.changeUrl({
        product: this.product,
        selectedVariant: this.selectedVariant,
      });

      if (!this.selectedVariant.available) {
        window._RestockRocket.renderButtonForVariant(this.selectedVariant.id);
      }
    },
    initMobileSlider() {
      this.mobileSlider = new Swiper(
        `.mobile-slider--${this.sectionId}.swiper`,
        {
          observer: true,
          resizeObserver: true,
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true, // Make the scrollbar draggable
            snapOnRelease: true, // Snap to slides when scrollbar is released
          },
          modules: [Scrollbar],
        }
      );
    },
    findVariantByPrevOptions({ product, prevOptions }) {
      if (prevOptions.length === 0) {
        const variant =
          product.variants.find((variant) => variant.available) ||
          product.variants[0];
        return { variant };
      }

      const variant = product.variants.find((variant) =>
        prevOptions.every((value) => variant.options.includes(value))
      );

      if (variant) {
        return { variant };
      }

      const newOptions = prevOptions.slice(0, -1);
      return this.findVariantByPrevOptions({
        product,
        prevOptions: newOptions,
      });
    },
    /* WORK WITH PRODUCT INSTANCE END */

    /* HANDLERS START | CORE LOGIC HERE */
    /* HANDLERS END | CORE LOGIC HERE */

    /* SET FUNCTIONS START */
    setInstance({ product, productOptions, selectedVariant }) {
      this.product = product;
      this.productOptions = productOptions;
      this.selectedVariant = selectedVariant;
      this.changeUrl({ product, selectedVariant });
    },
    async addToCartNonRX() {
      {
        try {
          const rxLensProduct = {
            id: this.rxLensSelectedVariant.id,
            quantity: 1,
            properties: {},
          };
          const frameProduct = {
            id: this.selectedVariant.id,
            quantity: 1,
            properties: {},
          };
          const frameName = this.frameName.toUpperCase();
          const sku = this.selectedVariant.sku;
          const frameDescription = ["EPOKHE", frameName, sku]
            .filter((val) => Boolean(val))
            .join(" ")
            .trim();

          const hash = new Date().getTime();
          const _bundleHash = `bundle-hash-${hash}-${this.rxLensSelectedVariant.id}-${this.selectedVariant.id}`;

          const healthFundItemNumbers = this.healthFundItemNumbers();
          rxLensProduct["properties"] = {
            "Frame Description": frameDescription,
            "_frame-image": this.product.media.filter(
              (item) => item.media_type === "image"
            )[0]
              ? this.product.media.filter(
                  (item) => item.media_type === "image"
                )[0].src
              : "",
            "Health Fund Item Numbers": healthFundItemNumbers,
            _bundleHash,
            _frame_variant_id: this.selectedVariant.id,
          };
          frameProduct["properties"] = { _bundleHash };

          const data = await addItems([rxLensProduct, frameProduct]);
          document.body.dispatchEvent(
            new CustomEvent("baseline:cart:afteradditem", {
              bubbles: true,
              detail: { response: data },
            })
          );
        } catch (e) {
          console.log(e);
        }
      }
    },
    addToCartReaders() {
      this.submitManualEntering();
    },
    async submitManualEntering() {
      const { left, right } = this.createPDValue();
      const payload = {
        eye_r: {
          sphere: this.SPH.R === "Choose" ? "0.00" : this.SPH.R,
          cylinder: {
            axis: "000",
            value: "0.00",
          },
          PD: left,
          add: {
            power: "0.00",
          },
        },
        eye_l: {
          sphere: this.SPH.L === "Choose" ? "0.00" : this.SPH.L,
          cylinder: {
            axis: "000",
            value: "0.00",
          },
          PD: right,
          add: {
            power: "0.00",
          },
        },
      };
      try {
        // const URL = `${this.URI}/api/store/prescriptions/json`;
        // this.isUploading = true;
        // const res = await fetch(URL, {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify(payload),
        // });
        // const data = await res.json();
        const frameName = this.frameName.toUpperCase();
        const sku = this.selectedVariant.sku;
        const frameDescription = ["EPOKHE", frameName, sku]
          .filter((val) => Boolean(val))
          .join(" ")
          .trim();

        const healthFundItemNumbers = this.healthFundItemNumbers();
        const properties = {
          _prescription_type: "manual",
          "Frame Description": frameDescription,
          "_frame-image": this.product.media.filter(
            (item) => item.media_type === "image"
          )[0]
            ? this.product.media.filter(
                (item) => item.media_type === "image"
              )[0].src
            : "",
          "Provider number": "592177MH",
          "Health Fund Item Numbers": healthFundItemNumbers,
          // Prescription: data.id,
          _frame_variant_id: this.selectedVariant.id,

          rxOrder: "true",
        };

        if (this.activePDOption === "SINGLE") {
          properties["Pupillary Distance"] = `${
            parseFloat(left) + parseFloat(right)
          }mm`;
        } else {
          properties["Pupillary Distance Left"] = `${parseFloat(left)}mm`;
          properties["Pupillary Distance Right"] = `${parseFloat(right)}mm`;
        }

        const rxLensProduct = {
          id: this.rxLensSelectedVariant.id,
          quantity: 1,
          properties,
        };
        const frameProduct = {
          id: this.selectedVariant.id,
          quantity: 1,
        };
        const hash = new Date().getTime();
        const _bundleHash = `bundle-hash-${hash}-${this.rxLensSelectedVariant.id}-${this.selectedVariant.id}`;

        rxLensProduct["properties"] = {
          ...rxLensProduct.properties,
          _bundleHash,
        };
        frameProduct["properties"] = { _bundleHash };

        const _data = await addItems([rxLensProduct, frameProduct]);
        document.body.dispatchEvent(
          new CustomEvent("baseline:cart:afteradditem", {
            bubbles: true,
            detail: { response: _data },
          })
        );
        this.isUploading = false;
      } catch (e) {
        this.isUploading = false;
        this.uploaded = false;
        console.log(e);
      }
    },
    setDefaultActiveTags(productTags) {
      productTags.forEach((tag) => {
        const [key] = tag.split("_");
        if (key in this.activeTags) {
          this.activeTags[key] = tag;
        }
      });
    },
    createPDValue() {
      let value = 32.0;
      if (this.activePDOption === "SINGLE") {
        value =
          this.PUPIL_RL.RL === "Choose"
            ? 32.0
            : parseFloat(this.PUPIL_RL.RL) / 2;

        return {
          right: value.toFixed(1),
          left: value.toFixed(1),
        };
      }
      return {
        right: this.PUPIL.R === "Choose" ? value.toFixed(1) : this.PUPIL.R,
        left: this.PUPIL.L === "Choose" ? value.toFixed(1) : this.PUPIL.L,
      };
    },
    healthFundItemNumbers() {
      const lensVariantTitleLowerCase =
        this.rxLensSelectedVariant.title.toLowerCase();
      const eyewear = this.rxLensProduct.tags.find((tag) =>
        tag.includes("eyewear_")
      );
      const values = [110];

      if (
        lensVariantTitleLowerCase.includes("colored") ||
        lensVariantTitleLowerCase.includes("polarized")
      ) {
        values.push(632);
      } else if (lensVariantTitleLowerCase.includes("transitions®")) {
        values.push(644);
      }

      switch (eyewear) {
        case "eyewear_Readers":
          values.push(212, 612);
          break;
        case "eyewear_Distance":
        case "eyewear_Progressive":
          values.push(512, 612);
          break;
        default:
          values.push(212, 612);
      }

      return values.join(", ");
    },
    setProductImagesByAlt() {
      const media = this.product.media.filter(
        (item) => item.media_type === "image"
      );
      const eyewear = this.rxLensProduct.tags.find((tag) =>
        tag.includes("eyewear_")
      );

      switch (eyewear) {
        case "eyewear_Sunglasses": {
          const lensFilterColorOption = this.rxLensProduct.productOptions.find(
            (option) => option.name.toLowerCase() === "lens filter color"
          );
          const mirrorOption = this.rxLensProduct.productOptions.find(
            (option) => option.name.toLowerCase() === "mirror"
          );

          const lensFilterOptionValue =
            this.rxLensSelectedVariant.options[
              lensFilterColorOption.position - 1
            ];

          const mirrorOptionValue =
            this.rxLensSelectedVariant.options[mirrorOption.position - 1];

          const targetAlt =
            mirrorOptionValue === "No Mirror"
              ? `${eyewear}~${lensFilterOptionValue}`
              : `${eyewear}~${mirrorOptionValue}`;

          const images = media.filter((img) =>
            img.alt ? img.alt === targetAlt : false
          );

          if (images.length === 0) {
            this.images = media;
          } else {
            this.images = images;
          }
          return;
        }
        case "eyewear_Photochromic": {
          const lensFilterColorOption = this.rxLensProduct.productOptions.find(
            (option) => option.name.toLowerCase() === "lens filter color"
          );
          const lensFilterOptionValue =
            this.rxLensSelectedVariant.options[
              lensFilterColorOption.position - 1
            ];

          const targetAlt = `${eyewear}~${lensFilterOptionValue}`;

          const images = media.filter((img) =>
            img.alt ? img.alt === targetAlt : false
          );

          if (images.length === 0) {
            this.images = media;
          } else {
            this.images = images;
          }
          return;
        }
        default: // eyewear_Clear-lens
          const targetAlt = `${eyewear}`;
          const images = media.filter((img) =>
            img.alt ? img.alt === targetAlt : false
          );

          if (images.length === 0) {
            this.images = media;
          } else {
            this.images = images;
          }
          return;
      }
    },
    /* SET FUNCTIONS END */

    /* UTILS START */
    changeUrl({ product, selectedVariant }) {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      url.pathname = `/products/${product.handle}`;
      params.set("variant", selectedVariant.id);

      const newUrl = `${url.origin}${url.pathname}?${params.toString()}${
        url.hash
      }`;

      history.replaceState(null, "", newUrl);
    },
    setCssVariables() {
      if (!document.querySelector(".js-frame-selector-wrapper")) {
        return;
      }

      const frameSelectorWrapperHeight = document
        .querySelector(".js-frame-selector-wrapper")
        .getBoundingClientRect().height;

      document.documentElement.style.setProperty(
        "--frame-selector-wrapper-height",
        `${frameSelectorWrapperHeight}px`
      );
    },
    findVariantByOptions({ product, options }) {
      return (
        product.variants.find(
          (variant) => variant.options.join() === options.join()
        ) || product.selectedVariant
      );
    },
    scrollHandler() {
      if (window.outerWidth > 767) return;
      const $html = document.querySelector("html");
      const $header = document.querySelector("header");
      const style = getComputedStyle($html);
      const cssVarHeaderHeightValue = style.getPropertyValue(
        "--header-inner-height"
      );

      if ($header.classList.contains("site-header--stuck")) {
        this.$el.style.top = cssVarHeaderHeightValue;
      } else {
        this.$el.style.top = 0;
      }
    },
    async getDataFromPage(url) {
      try {
        const resText = await fetch(url);
        const html = await resText.text();
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, "text/html");
        const shopProducts = JSON.parse(
          htmlDoc.getElementById("all-products").textContent
        );
        return shopProducts;
      } catch (e) {
        console.log(e);
      }
    },
    async getProductMediaAjax(url) {
      try {
        const resText = await fetch(url);
        const html = await resText.text();
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, "text/html");
        const newSlider = htmlDoc.getElementById("product-slider");
        const container = document.querySelector("[ev-data-slider-container]");
        container.innerHTML = newSlider.outerHTML;
      } catch (e) {
        console.log(e);
      }
    },
    /* UTILS END */

    /* ADD TO CART LOGIC START */
    async addToCart() {
      const data = { items: [] };
      const item = {
        id: this.selectedVariant.id,
        quantity: 1,
        variantTitle: this.selectedVariant.name,
        variantPrice: this.selectedVariant.price,
        properties: {
          _prescription_type: "file", //'manual', 'file'
          _rx_values: null,
        },
      };
      if (this.prescriptionItems.length) {
        this.prescriptionItems.forEach((uploadItem, index) => {
          item.properties[`Prescription`] = uploadItem.url;
          item.properties[`_rx_values`] = uploadItem.rx_values;
          item.properties[`_prescription_type`] = uploadItem.prescription_type;
        });
        this.prescriptionItems = [];
      }
      data.items.push(item);

      await this.$store.cart.addToCart(data.items, true);
      this.togglePrescriptionPopup();
    },
    /* ADD TO CART LOGIC END */

    /* TOGGLERS START */
    toggleFramePopup() {
      this.isOpenFramePopup = !this.isOpenFramePopup;

      if (this.isOpenFramePopup === true) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        this.$store.stopScroll.enable();
      } else {
        this.$store.stopScroll.disable();
      }
    },
    togglePrescriptionPopup() {
      this.isOpenPrescriptionPopup = !this.isOpenPrescriptionPopup;

      if (this.isOpenPrescriptionPopup === true) {
        window.scrollTo({
          top: 0,
        });
        document.documentElement.classList.add("prescription-popup-opened");
        this.$store.stopScroll.enable();
      } else {
        document.documentElement.classList.remove("prescription-popup-opened");
        this.$store.stopScroll.disable();
      }
    },
    closePrescriptionPopup() {
      this.isOpenPrescriptionPopup = false;
      document.documentElement.classList.remove("prescription-popup-opened");
      this.$store.stopScroll.disable();
    },
    toggleSizeGuidePopup() {
      this.isOpenSizeGuidePopup = !this.isOpenSizeGuidePopup;

      if (this.isOpenSizeGuidePopup === true) {
        this.$store.stopScroll.enable();
      } else {
        this.$store.stopScroll.disable();
      }
    },
    /* TOGGLERS END */

    /* GETTERS START */
    get frameName() {
      const frameTag = this.product.tags.find((tag) => tag.includes("frame_"));
      return frameTag ? frameTag.replace("frame_", "").split("~")[0] : "";
    },
    get frameNameWithColor() {
      const frameTag = this.product.tags.find((tag) => tag.includes("frame_"));
      return frameTag
        ? frameTag.replace("frame_", "").toLowerCase().trim()
        : "";
    },
    get frameGroup() {
      const frameTag = this.product.tags.find((tag) => tag.includes("frame_"));
      return frameTag ? frameTag.split("~")[0].split("_")[1] : "";
    },
    get frameColor() {
      const frameTag = this.product.tags.find((tag) => tag.includes("frame_"));
      return frameTag ? frameTag.split("~")[1] : "";
    },
    // get compareAtPrice() {
    //   if (
    //     this.selectedVariant.compare_at_price &&
    //     this.selectedVariant.compare_at_price > this.selectedVariant.price &&
    //     this.rxLensSelectedVariant.compare_at_price &&
    //     this.rxLensSelectedVariant.compare_at_price >
    //       this.rxLensSelectedVariant.price
    //   ) {
    //     return (
    //       this.selectedVariant.compare_at_price +
    //       this.rxLensSelectedVariant.compare_at_price
    //     );
    //   }
    //
    //   if (
    //     this.selectedVariant.compare_at_price &&
    //     this.selectedVariant.compare_at_price > this.selectedVariant.price &&
    //     !this.rxLensSelectedVariant.compare_at_price
    //   ) {
    //     return (
    //       this.selectedVariant.compare_at_price + this.rxLensSelectedVariant.price
    //     );
    //   }
    //
    //   if (
    //     this.rxLensSelectedVariant.compare_at_price &&
    //     this.rxLensSelectedVariant.compare_at_price >
    //       this.rxLensSelectedVariant.price &&
    //     !this.selectedVariant.compare_at_price
    //   ) {
    //     return (
    //       this.rxLensSelectedVariant.compare_at_price + this.selectedVariant.price
    //     );
    //   }
    //
    //   return null;
    // },
    get compareAtPrice() {
      let originalPrice = 0;
      let newPrice = 0;

      if (
        this.selectedVariant.compare_at_price &&
        this.selectedVariant.compare_at_price > this.selectedVariant.price
      ) {
        originalPrice += this.selectedVariant.compare_at_price;
        newPrice += this.selectedVariant.price;
      } else {
        originalPrice += this.selectedVariant.price;
        newPrice += this.selectedVariant.price;
      }

      if (
        this.rxLensSelectedVariant.compare_at_price &&
        this.rxLensSelectedVariant.compare_at_price >
          this.rxLensSelectedVariant.price
      ) {
        originalPrice += this.rxLensSelectedVariant.compare_at_price;
        newPrice += this.rxLensSelectedVariant.price;
      } else {
        originalPrice += this.rxLensSelectedVariant.price;
        newPrice += this.rxLensSelectedVariant.price;
      }

      if (originalPrice > newPrice) {
        const discountAmount = originalPrice - newPrice;
        const discountPercentage = (
          (discountAmount / originalPrice) *
          100
        ).toFixed(0);

        return {
          price: originalPrice,
          percentage: `${discountPercentage}%`,
        };
      }

      return null;
    },
    getVariantsByTitleChunks(chunks) {
      const variants = this.rxLensProduct.variants.filter((variant) =>
        chunks.every((chunk) => variant.title.includes(chunk))
      );

      return variants;
    },
    replaceWordsFromString({ words, string }) {
      let str = string;
      words.forEach((word) => (str = str.replace(new RegExp(word, "g"), "")));
      return str.trim();
    },
    allUniqLensOptionsByEyewear(eyewear) {
      switch (eyewear) {
        case "eyewear_Non-RX": {
          const variants = this.rxLensProduct.variants;
          const colorGroups = [
            ...new Set(variants.map((v) => v.title.split("/")[0].trim())),
          ];

          return { colorGroups };
        }
        case "eyewear_Distance":
        case "eyewear_Progressive": {
          const variants = this.rxLensProduct.variants;
          const materialGroups = [
            ...new Set(variants.map((v) => v.title.split("/")[0].trim())),
          ];
          const colorGroups = [
            ...new Set(variants.map((v) => v.title.split("/")[1].trim())),
          ];

          return { materialGroups, colorGroups };
        }
      }
    },
    /* GETTERS END */
  }));
});
